import { useEffect, useState } from "react";
import moment from "moment";
import { ConfirmButton } from "../../components/ConfirmButton";
import { EditableCell, EditableRow } from "../../components/EditableCell";
import { getEventPersonnels, updateEventPersonnel } from "../../services/eventPersonnelServices";
import {
    addEventSupplierPersonnelRequests,
    deleteEventSupplierPersonnelRequests,
    getEventSupplierPersonnelRequests,
    updateEventSupplierPersonnelRequests,
} from "../../services/eventSupplierPersonnelRequestServices";
import { getEventSuppliers } from "../../services/eventSupplierServices";
import { notification } from "../../helpers/notification";

export const EventSupplier = (props) => {
    const [supplierList, setSupplierList] = useState([]);
    const [open, setOpen] = useState(false);
    const [activeSupplier, setActiveSupplier] = useState(null);
    const [eventPersonnelList, setEventPersonnelList] = useState([]);
    const [supplierPersonnelRequestList, setSupplierPersonnelRequestList] = useState([]);
    const [formValues, setFormValues] = useState({
        supplierUniqueKey: "",
        chiefCount: 0,
        oggCount: 0,
        alternateChiefCount: 0,
        alternateOGGCount: 0,
    });
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 50;

    const getData = () => {
        getEventSupplierPersonnelRequests(props.uniqueKey).then((requests) => {
            getEventSuppliers().then((suppliers) => {
                setSupplierList(suppliers.items.sort((a, b) => a.name.localeCompare(b.name)));
                setSupplierPersonnelRequestList(requests.items);
            });
        });
    };

    const changePersonnelStatus = (uniqueKey, status) => {
        updateEventPersonnel({
            uniqueKey: uniqueKey,
            isApproved: status,
        }).then(() => {
            const newList = [];
            eventPersonnelList.forEach((item) => {
                if (item.uniqueKey == uniqueKey) item.isApproved = status;
                newList.push(item);
            });
            setEventPersonnelList(newList);
        });
    };

    const saveForm = (e) => {
        e.preventDefault();
        const values = formValues;
        if (values.chiefCount == 0 && values.oggCount == 0) {
            notification.warning({
                message: "Tedarikçi eklenebilmesi için Amir veya Özel Güvenlik sayılarından birinin 0'dan büyük olması gerekmekte.",
            });
            return;
        }
        if (supplierPersonnelRequestList.find((f) => f.supplierUniqueKey == values.supplierUniqueKey)) {
            notification.warning({
                message: "Tedarikçi daha önce eklenmiş.",
            });
            return;
        }
        values["eventUniqueKey"] = props.uniqueKey;
        addEventSupplierPersonnelRequests(values).then(() => {
            notification.success({
                message: "Tedarikçi başarıyla eklendi.",
            });
            getData();
        });
    };

    const onDeleteConfirm = (uniqueKey) => {
        deleteEventSupplierPersonnelRequests(uniqueKey).then(() => {
            notification.success({
                message: "Tedarikçi başarıyla silindi.",
            });
            getData();
        });
    };

    const onShowPersonnels = (sup, tp) => {
        getEventPersonnels(props.uniqueKey, false, null, null, sup.supplierUniqueKey).then((result) => {
            result.items.map((m, i) => {
                m["index"] = i + 1;
            });
            setEventPersonnelList(result.items.filter((w) => w.personnelType == tp));
            setActiveSupplier(sup);
            setOpen(true);
        });
    };

    const excelExport = () => {
        getEventPersonnels(props.uniqueKey, false, "excel", null, activeSupplier.supplierUniqueKey).then((result) => {
            const url = window.URL.createObjectURL(new Blob([result]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Etkinlik Personel Listesi.xlsx");
            document.body.appendChild(link);
            link.click();
            return;
        });
    };

    const handleFormChange = (field, value) => {
        setFormValues((prev) => ({ ...prev, [field]: value }));
    };

    const totalChiefCount = supplierPersonnelRequestList.reduce((sum, a) => sum + (Number(a.chiefCount) || 0), 0);
    const totalOggCount = supplierPersonnelRequestList.reduce((sum, a) => sum + (Number(a.oggCount) || 0), 0);
    const totalAlternateChiefCount = supplierPersonnelRequestList.reduce((sum, a) => sum + (Number(a.alternateChiefCount) || 0), 0);
    const totalAlternateOggCount = supplierPersonnelRequestList.reduce((sum, a) => sum + (Number(a.alternateOGGCount) || 0), 0);
    const totalAddedChiefCount = supplierPersonnelRequestList.reduce((sum, a) => sum + (Number(a.addedChiefCount) || 0), 0);
    const totalAddedOggCount = supplierPersonnelRequestList.reduce((sum, a) => sum + (Number(a.addedOGGCount) || 0), 0);
    const totalRequestedCount = totalChiefCount + totalOggCount;
    const totalAddedCount = totalAddedChiefCount + totalAddedOggCount;
    const remainingCount = totalRequestedCount - totalAddedCount;
    const completionRate = totalRequestedCount > 0 ? Math.min(100, Math.round((totalAddedCount / totalRequestedCount) * 100)) : 0;

    const columns = [
        {
            title: (
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                    <span>Tedarikçi Adı</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-300" title="Toplam Talep">
                        {totalRequestedCount}
                    </span>
                </div>
            ),
            dataIndex: "supplierName",
            width: 200,
        },
        {
            title: (
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                    <span>Amir</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-300">
                        {totalChiefCount}
                    </span>
                </div>
            ),
            dataIndex: "chiefCount",
            render: (text, record) => (
                <EditableCell
                    title="Amir Sayısı"
                    record={record}
                    dataIndex="chiefCount"
                    inputType="number"
                    handleSave={(values) => {
                        updateEventSupplierPersonnelRequests({
                            uniqueKey: values.uniqueKey,
                            chiefCount: values.chiefCount,
                            oggCount: values.oggCount,
                        }).then(() => {
                            const newList = [];
                            supplierPersonnelRequestList.forEach((item) => {
                                if (item.uniqueKey == values.uniqueKey) item.chiefCount = values.chiefCount;
                                newList.push(item);
                            });
                            setSupplierPersonnelRequestList(newList);
                        });
                    }}
                />
            ),
        },
        {
            title: (
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                    <span>ÖGG</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-indigo-100 text-indigo-700 dark:bg-indigo-900/50 dark:text-indigo-300">
                        {totalOggCount}
                    </span>
                </div>
            ),
            dataIndex: "oggCount",
            render: (text, record) => (
                <EditableCell
                    title="ÖGG Sayısı"
                    record={record}
                    dataIndex="oggCount"
                    inputType="number"
                    handleSave={(values) => {
                        updateEventSupplierPersonnelRequests({
                            uniqueKey: values.uniqueKey,
                            chiefCount: values.chiefCount,
                            oggCount: values.oggCount,
                        }).then(() => {
                            const newList = [];
                            supplierPersonnelRequestList.forEach((item) => {
                                if (item.uniqueKey == values.uniqueKey) item.oggCount = values.oggCount;
                                newList.push(item);
                            });
                            setSupplierPersonnelRequestList(newList);
                        });
                    }}
                />
            ),
        },
        {
            title: (
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                    <span>Yedek Amir</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-300">
                        {totalAlternateChiefCount}
                    </span>
                </div>
            ),
            dataIndex: "alternateChiefCount",
            render: (text, record) => (
                <EditableCell
                    title="Yedek Amir"
                    record={record}
                    dataIndex="alternateChiefCount"
                    inputType="number"
                    handleSave={(values) => {
                        updateEventSupplierPersonnelRequests({
                            uniqueKey: values.uniqueKey,
                            alternateChiefCount: values.alternateChiefCount,
                            alternateOGGCount: values.alternateOGGCount,
                        }).then(() => {
                            const newList = [];
                            supplierPersonnelRequestList.forEach((item) => {
                                if (item.uniqueKey == values.uniqueKey) item.alternateChiefCount = values.alternateChiefCount;
                                newList.push(item);
                            });
                            setSupplierPersonnelRequestList(newList);
                        });
                    }}
                />
            ),
        },
        {
            title: (
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                    <span>Yedek ÖGG</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-300">
                        {totalAlternateOggCount}
                    </span>
                </div>
            ),
            dataIndex: "alternateOGGCount",
            render: (text, record) => (
                <EditableCell
                    title="Yedek ÖGG"
                    record={record}
                    dataIndex="alternateOGGCount"
                    inputType="number"
                    handleSave={(values) => {
                        updateEventSupplierPersonnelRequests({
                            uniqueKey: values.uniqueKey,
                            alternateChiefCount: values.alternateChiefCount,
                            alternateOGGCount: values.alternateOGGCount,
                        }).then(() => {
                            const newList = [];
                            supplierPersonnelRequestList.forEach((item) => {
                                if (item.uniqueKey == values.uniqueKey) item.alternateOGGCount = values.alternateOGGCount;
                                newList.push(item);
                            });
                            setSupplierPersonnelRequestList(newList);
                        });
                    }}
                />
            ),
        },
        {
            title: (
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                    <span>Girilen Amir</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300">
                        {totalAddedChiefCount}
                    </span>
                </div>
            ),
            dataIndex: "addedChiefCount",
        },
        {
            title: (
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                    <span>Girilen ÖGG</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300">
                        {totalAddedOggCount}
                    </span>
                </div>
            ),
            dataIndex: "addedOGGCount",
        },
        {
            title: (
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                    <span>Toplam Girilen</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-300">
                        {totalAddedCount}
                    </span>
                </div>
            ),
            key: "action",
            width: "200px",
            render: (text, record) => (
                <div className="flex gap-2 table-action">
<button title="Amir Listesi" onClick={() => onShowPersonnels(record, 1)} className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-colors">
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
</button>
<button title="ÖGG Listesi" onClick={() => onShowPersonnels(record, 2)} className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors">
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
</button>
                    <ConfirmButton onConfirm={() => onDeleteConfirm(record.uniqueKey)} message="Tedarikçiyi silmek istediğinizden emin misiniz?">
                        <button className="app-btn btn-red">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                        </button>
                    </ConfirmButton>
                </div>
            ),
        },
    ];

    const personnelColumns = [
        {
            title: "No",
            dataIndex: "index",
            key: "index",
            width: 40,
            render: (text, record) => <div>{text}</div>,
        },
        {
            title: "Adı",
            dataIndex: "name",
            key: "name",
            render: (text, record) => <div>{text}</div>,
        },
        {
            title: "Soyadı",
            dataIndex: "surname",
            key: "surname",
            render: (text, record) => <div>{text}</div>,
        },
        {
            title: "TC Kimlik",
            dataIndex: "identityNumber",
            key: "identityNumber",
            render: (text, record) => <div>{text}</div>,
        },
        {
            title: "ÖGG",
            dataIndex: "oggNumber",
            key: "oggNumber",
            render: (text, record) => (
                <div className="inline-flex items-center gap-1.5">
                    <span>{text || "-"}</span>
                    {record.oggExpireDate && (
                        <span
                            className="relative group inline-flex items-center cursor-pointer text-blue-500 hover:text-blue-600"
                            title={`ÖGG Bitiş Tarihi: ${moment(record.oggExpireDate).format("DD.MM.YYYY")}`}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:flex px-2 py-1 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap z-50 pointer-events-none">
                                Bitiş: {moment(record.oggExpireDate).format("DD.MM.YYYY")}
                            </span>
                        </span>
                    )}
                </div>
            ),
        },
        {
            title: "Görevi",
            dataIndex: "personnelType",
            key: "personnelType",
            render: (text, record) => (
                <div>{(text == "1" ? "Amir" : text == "3" ? "Özel Güvenlik Sorumlusu" : "Özel Güvenlik") + (record.isRetired ? " (Emekli)" : "")}</div>
            ),
        },
        {
            title: "Akredite",
            dataIndex: "isApproved",
            key: "isApproved",
            render: (text, record) => (
                <div>
                    {record.personnelType == 1 ? (
                        <button
                            type="button"
                            onClick={() => changePersonnelStatus(record.uniqueKey, !record.isApproved)}
                            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${record.isApproved ? "bg-green-500" : "bg-gray-300"}`}
                        >
                            <span
                                className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${record.isApproved ? "translate-x-[18px]" : "translate-x-[2px]"}`}
                            />
                        </button>
                    ) : (
                        "-"
                    )}
                </div>
            ),
        },
    ];

    useEffect(() => {
        getData();
    }, [props.uniqueKey]);

    const renderSupplierModalCards = () => {
        if (!eventPersonnelList || eventPersonnelList.length === 0) {
            return <div className="mobile-empty-text">⚠ Etkinlik için tedarikçinin herhangi bir akreditesi bulunmuyor.</div>;
        }
        return eventPersonnelList.map((record) => (
            <div key={record.uniqueKey} className={`modal-personnel-card ${record.isAttended ? "attended" : ""}`}>
                <div className="modal-card-header">
                    <div className="modal-card-no">#{record.index}</div>
                    <div className="modal-card-name">{record.name} {record.surname}</div>
                    <div className="modal-card-type">
                        {(record.personnelType == 1 ? "Amir" : record.personnelType == 3 ? "Özel Güvenlik Sorumlusu" : "ÖGG") + (record.isRetired ? " (Emekli)" : "")}
                    </div>
                </div>
                <div className="modal-card-body">
                    <div className="modal-card-row">
                        <span className="info-label">TC Kimlik</span>
                        <span className="info-value">{record.identityNumber}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">ÖGG No</span>
                        <span className="info-value">{record.oggNumber || "-"}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">ÖGG Bitiş</span>
                        <span className="info-value">{record.oggExpireDate ? moment(record.oggExpireDate).format("DD.MM.YYYY") : "-"}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">Akredite</span>
                        <span className="info-value">
                            {record.personnelType == 1 ? (
                                <button
                                    type="button"
                                    onClick={() => changePersonnelStatus(record.uniqueKey, !record.isApproved)}
                                    className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${record.isApproved ? "bg-green-500" : "bg-gray-300"}`}
                                >
                                    <span
                                        className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${record.isApproved ? "translate-x-[18px]" : "translate-x-[2px]"}`}
                                    />
                                </button>
                            ) : (
                                "-"
                            )}
                        </span>
                    </div>
                </div>
            </div>
        ));
    };

    const totalPages = Math.ceil(supplierPersonnelRequestList.length / pageSize);
    const paginatedData = supplierPersonnelRequestList.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <>
            <form onSubmit={saveForm} className="mb-6">
                <div className="flex flex-wrap items-end gap-4">
                    <div className="flex-1 min-w-[200px]">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tedarikçi</label>
                        <select
                            value={formValues.supplierUniqueKey}
                            onChange={(e) => handleFormChange("supplierUniqueKey", e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        >
                            <option value="">Seçiniz</option>
                            {supplierList.map((m) => (
                                <option key={m.uniqueKey} value={m.uniqueKey}>
                                    {m.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="w-24">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Amir</label>
                        <input
                            type="number"
                            placeholder="Amir"
                            value={formValues.chiefCount}
                            onChange={(e) => handleFormChange("chiefCount", Number(e.target.value))}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                    </div>
                    <div className="w-24">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">ÖGG</label>
                        <input
                            type="number"
                            placeholder="ÖGG"
                            value={formValues.oggCount}
                            onChange={(e) => handleFormChange("oggCount", Number(e.target.value))}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                    </div>
                    <div className="w-28">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Yedek Amir</label>
                        <input
                            type="number"
                            placeholder="Yedek Amir"
                            value={formValues.alternateChiefCount}
                            onChange={(e) => handleFormChange("alternateChiefCount", Number(e.target.value))}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                    </div>
                    <div className="w-28">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Yedek ÖGG</label>
                        <input
                            type="number"
                            placeholder="Yedek ÖGG"
                            value={formValues.alternateOGGCount}
                            onChange={(e) => handleFormChange("alternateOGGCount", Number(e.target.value))}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                    </div>
                    <div className="flex items-start">
                        <button type="submit" className="app-btn btn-green">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                            <span>Tedarikçiyi Ekle</span>
                        </button>
                    </div>
                </div>
            </form>

            {/* Özet Metrik Kartları (TOPLAM TALEP, GİRİLEN PERSONEL, KALAN KONTENJAN) */}
            <div className="mb-4">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {/* Toplam Talep */}
                    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-3 shadow-sm flex items-center justify-between">
                        <div>
                            <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">TOPLAM TALEP</p>
                            <p className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mt-0.5">{totalRequestedCount}</p>
                            <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">
                                Amir: <span className="font-semibold text-gray-700 dark:text-gray-300">{totalChiefCount}</span> · ÖGG: <span className="font-semibold text-gray-700 dark:text-gray-300">{totalOggCount}</span> · Yedek: <span className="font-semibold text-gray-700 dark:text-gray-300">{totalAlternateChiefCount + totalAlternateOggCount}</span>
                            </p>
                        </div>
                        <div className="w-9 h-9 rounded-lg bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 flex items-center justify-center shrink-0">
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                            </svg>
                        </div>
                    </div>

                    {/* Girilen Personel */}
                    <div className="bg-green-50/70 dark:bg-green-950/30 border border-green-200 dark:border-green-800/60 rounded-lg p-3 shadow-sm flex items-center justify-between">
                        <div>
                            <p className="text-[11px] font-semibold uppercase tracking-wider text-green-700 dark:text-green-300">GİRİLEN PERSONEL</p>
                            <p className="text-xl sm:text-2xl font-bold text-green-700 dark:text-green-400 mt-0.5">{totalAddedCount}</p>
                            <p className="text-[11px] text-green-600 dark:text-green-400 mt-0.5">
                                Amir: <span className="font-semibold">{totalAddedChiefCount}</span> · ÖGG: <span className="font-semibold">{totalAddedOggCount}</span>
                            </p>
                        </div>
                        <div className="w-9 h-9 rounded-lg bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 flex items-center justify-center shrink-0">
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                    </div>

                    {/* Kalan Kontenjan */}
                    <div className={`${remainingCount <= 0 ? 'bg-green-50/70 dark:bg-green-950/30 border-green-200 dark:border-green-800/60' : 'bg-red-50/70 dark:bg-red-950/30 border-red-200 dark:border-red-800/60'} border rounded-lg p-3 shadow-sm flex items-center justify-between`}>
                        <div>
                            <p className={`text-[11px] font-semibold uppercase tracking-wider ${remainingCount <= 0 ? 'text-green-700 dark:text-green-300' : 'text-red-700 dark:text-red-300'}`}>KALAN KONTENJAN</p>
                            <p className={`text-xl sm:text-2xl font-bold ${remainingCount <= 0 ? 'text-green-700 dark:text-green-400' : 'text-red-700 dark:text-red-400'} mt-0.5`}>
                                {remainingCount <= 0 ? 0 : remainingCount}
                            </p>
                            <p className={`text-[11px] mt-0.5 ${remainingCount <= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
                                {remainingCount <= 0 ? 'Tüm kontenjan dolduruldu' : `${remainingCount} personel bekleniyor`}
                            </p>
                        </div>
                        <div className={`w-9 h-9 rounded-lg ${remainingCount <= 0 ? 'bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300' : 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300'} flex items-center justify-center shrink-0`}>
                            {remainingCount <= 0 ? (
                                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                </svg>
                            ) : (
                                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                                </svg>
                            )}
                        </div>
                    </div>
                </div>

                {/* Doluluk İlerleme Çubuğu */}
                {totalRequestedCount > 0 && (
                    <div className="mt-2 bg-gray-200 dark:bg-gray-700 rounded-full h-1.5 overflow-hidden">
                        <div
                            className="bg-green-500 h-1.5 rounded-full transition-all duration-300"
                            style={{ width: `${completionRate}%` }}
                        />
                    </div>
                )}
            </div>

            <div className="mobile-tab-cards">
                {supplierPersonnelRequestList.length === 0 ? (
                    <div className="mobile-empty-text">⚠ Etkinliğe henüz tedarikçi eklenmemiş.</div>
                ) : (
                    supplierPersonnelRequestList.map((record) => (
                        <div key={record.uniqueKey} className="supplier-mobile-card">
                            <div className="supplier-card-header">
                                <div className="supplier-card-name">{record.supplierName}</div>
                            </div>
                            <div className="supplier-card-body">
                                <div className="supplier-card-stats">
                                    <div className="supplier-card-stat">
                                        <span className="stat-label">Amir</span>
                                        <span className="stat-value">{record.chiefCount}</span>
                                    </div>
                                    <div className="supplier-card-stat">
                                        <span className="stat-label">ÖGG</span>
                                        <span className="stat-value">{record.oggCount}</span>
                                    </div>
                                    <div className="supplier-card-stat">
                                        <span className="stat-label">Y. Amir</span>
                                        <span className="stat-value">{record.alternateChiefCount}</span>
                                    </div>
                                    <div className="supplier-card-stat">
                                        <span className="stat-label">Y. ÖGG</span>
                                        <span className="stat-value">{record.alternateOGGCount}</span>
                                    </div>
                                    <div className="supplier-card-stat">
                                        <span className="stat-label">G. Amir</span>
                                        <span className="stat-value">{record.addedChiefCount}</span>
                                    </div>
                                    <div className="supplier-card-stat">
                                        <span className="stat-label">G. ÖGG</span>
                                        <span className="stat-value">{record.addedOGGCount}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="supplier-card-footer">
                                <button className="app-btn btn-ghost no-icon" onClick={() => onShowPersonnels(record, 1)}>
                                    <span>Amir Listesi</span>
                                </button>
                                <button className="app-btn btn-ghost no-icon" onClick={() => onShowPersonnels(record, 2)}>
                                    <span>ÖGG Listesi</span>
                                </button>
                                <ConfirmButton onConfirm={() => onDeleteConfirm(record.uniqueKey)} message="Tedarikçiyi silmek istediğinizden emin misiniz?">
                                    <button className="app-btn btn-red">
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                                    </button>
                                </ConfirmButton>
                            </div>
                        </div>
                    ))
                )}
            </div>
            <div className="desktop-tab-table">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                            <tr>
                                {columns.map((col, idx) => (
                                    <th
                                        key={idx}
                                        className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
                                        style={col.width ? { width: col.width } : undefined}
                                    >
                                        {col.title}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                            {paginatedData.length === 0 ? (
                                <tr>
                                    <td colSpan={columns.length} className="px-3 py-8 text-center text-gray-500 dark:text-gray-400">
                                        ⚠ Etkinliğe henüz tedarikçi eklenmemiş.
                                    </td>
                                </tr>
                            ) : paginatedData.map((record) => (
                                <tr key={record.uniqueKey} className="hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800">
                                    {columns.map((col, idx) => (
                                        <td key={idx} className="px-3 py-2 whitespace-nowrap">
                                            {col.render
                                                ? col.render(record[col.dataIndex], record)
                                                : record[col.dataIndex]}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 && (
                    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 dark:border-gray-700">
                        <span className="text-sm text-gray-700 dark:text-gray-300">Toplam {supplierPersonnelRequestList.length} kayıt bulundu</span>
                        <div className="flex items-center gap-2">
                            <button
                                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                                className="px-3 py-1 text-sm border border-gray-300 rounded disabled:opacity-50 hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800"
                            >
                                Önceki
                            </button>
                            <span className="text-sm text-gray-700 dark:text-gray-300">{currentPage} / {totalPages}</span>
                            <button
                                onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                                className="px-3 py-1 text-sm border border-gray-300 rounded disabled:opacity-50 hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800"
                            >
                                Sonraki
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {open && activeSupplier ? (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => { getData(); setOpen(false); }}></div>
                    <div className="relative bg-white dark:bg-gray-900 rounded-lg shadow-xl max-w-6xl w-full mx-4 max-h-[90vh] flex flex-col">
                        <div className="flex items-center justify-between p-4 border-b">
                            <h3 className="text-lg font-semibold">{activeSupplier.supplierName}</h3>
                            <div className="flex items-center gap-3">
                                <button
                                    className="app-btn btn-green"
                                    onClick={() => excelExport()}
                                >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                                    <span>Tüm Liste Excel'e Aktar</span>
                                </button>
                                <button onClick={() => { getData(); setOpen(false); }} className="text-gray-400 hover:text-gray-600">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="overflow-auto flex-1 p-4">
                            <div className="mobile-modal-cards">
                                {renderSupplierModalCards()}
                            </div>
                            <div className="desktop-modal-table">
                                {eventPersonnelList.length === 0 ? (
                                    <div className="text-center text-gray-500 dark:text-gray-400 py-8">⚠ Etkinlik için tedarikçinin herhangi bir akreditesi bulunmuyor.</div>
                                ) : (
                                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                        <thead className="bg-gray-50 dark:bg-gray-800">
                                            <tr>
                                                {personnelColumns.map((col, idx) => (
                                                    <th key={idx} className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase" style={col.width ? { width: col.width } : undefined}>
                                                        {col.title}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                            {eventPersonnelList.map((record) => (
                                                <tr key={record.uniqueKey} className={`hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800 ${record.isAttended ? "bg-green-50" : ""}`}>
                                                    {personnelColumns.map((col, idx) => (
                                                        <td key={idx} className="px-3 py-2 whitespace-nowrap">
                                                            {col.render
                                                                ? col.render(record[col.dataIndex], record)
                                                                : record[col.dataIndex]}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
};
